import React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { LinkButton, ContentBlock } from "@onelogin/react-components";
import styled from "styled-components";
import { openSupportWindow } from "../actions/supportActions";

const LargeLinkButton = styled(LinkButton)`
  width: 100%;
`;

const SupportButton = ({ open }) => (
  <ContentBlock>
    <LargeLinkButton onClick={open}>
      <FormattedMessage
        id="help"
        defaultMessage="Help"
      />
    </LargeLinkButton>
  </ContentBlock>
);

const SupportLink = ({ supportEnabled, open }) => {
  return supportEnabled
    ? <SupportButton open={open} />
    : null;
};

const mapStateToProps = state => ({
  supportEnabled: state.branding.data.support.enable_support
});

const mapDispatchToProps = dispatch => ({
  open: () => dispatch(openSupportWindow())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SupportLink);
